<template>
  <div id="floatDrag" class="helpIconPage float-position" ref="floatDrag" 
  :style="{ left: left + 'px', top: top + 'px',width:width}" @mousedown="startDrag">
    <transition name="draw">
      <div
        class="right_top"
        style="width: 450px; height: 160px;"
        v-show="show1 === true"
        v-loading="loading">
        <div class="right_all" style="flex-direction: column">
          <div
            class="left_img"
            style="
              display: flex;
              justify-content: flex-start;
              align-items: center;">
            <img src="../../assets/iphone.png"  @click="clickShow1"/>
            <div class="iphone_text">
              <div class="iphone">
                <span>客服电话：0755-82794696</span>
                <span style="margin-left: 15px">0755-82790596</span>
              </div>
              <div class="work-time">
                工作时间：9:00-12:00,14:00-18:00(工作日)
              </div>
            </div>
          </div>
          <div v-if="userInfo.DeptType !='开发建设单位'"
            style="
              display: flex;
              justify-content: space-evenly;
              align-items: center;
              flex-direction: row;
              margin-top: 10px;
              position: relative; 
              width: 100%;">
            <ul
              v-if="helpList.length"
              style="max-height: 90px; overflow-y: auto; margin-right: 10px;width: calc(100% - 60px);word-wrap: break-word;">
              <li
                @click.stop="toWord(item)"
                v-for="(item, index) in helpList"
                :key="index"
                style="margin-top: 10px">
                《{{ item.DocTitle }}》
              </li>
            </ul>
            <i
              class="el-icon-arrow-right"
              @click="clickShow1"
              style="
                font-size: 20px;
                width: 60px;
                line-height: 90px;
                height: 90px;"></i>
          </div>
        </div>
        <el-dialog title="预览" :visible.sync="showDialog">
          <pdf :src="src"></pdf>
        </el-dialog>
      </div>
    </transition>
    <transition name="drawdowm">
      <div
        class="right_top"
        style="width: 77px; height:60px;"
        v-show="show1 === false">
        <div class="right_all">
          <div class="left_img"  @click="clickShow1">
            <img src="../../assets/iphone.png"/>
            <div>帮助</div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { HelpControllerSvr } from '@/service/HelpControllerSvr.js';
import { previewPdf } from '@/utils/downLoadPdf';
import { baseUrl } from '@/assets/js/division';
export default {
  data() {
    return {
      src: '',
      showDialog: false,
      showNull: false,
      data: '',
      helpControllerSvr: new HelpControllerSvr(),
      show1: true,
      loading: false,
      helpList: [],
      baseURL: baseUrl(),
      left: null,
      top: null,
      right: null,
      timer: null,
      currentTop: 0,
      floatDragDom:{},
      floatDrag:{},
      width:'450px',
      canClick:true,
      dragElement:{},
      //拖拽代码
      isDragging:false,
      startX: 0,
      startY: 0,
      dragBoxOffsetX: 0,
      dragBoxOffsetY: 0
    };
  },
  props: {
    distanceRight: {
      type: Number,
      default: 8,
    },
    distanceBottom: {
      type: Number,
      default: 8,
    },
    isScrollHidden: {
      type: Boolean,
      default: false,
    },
    isCanDraggable: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapState(['token', 'userInfo']),
  },
  mounted() {
    this.initLeftATop();
    this.loading = true;
    this.helpControllerSvr
      .getDocList(this.token)
      .then((res) => {
        this.loading = false;
        this.helpList = res;
      })
      .catch((err) => {
        this.loading = false;
        this.$message({
          type: 'error',
          message: err,
        });
      });
    const that = this;
    window.addEventListener('resize', function () {
      that.initLeftATop();
    });
  },
  watch: { // 监听,当路由发生变化的时候执行
  '$route.path': {
      handler(toPath, fromPath){
          this.initLeftATop();
      },
      deep: true, // 深度监听
      immediate: true, // 第一次初始化渲染就可以监听到
    },
  },
  methods: {
    toWord(item) {
      const seePdfUrl = `${
        this.baseURL
      }ImportantWeixinFaqDoc.svt/checkImportantFaq?id=${
        item.DocId
      }`;
      const loading = this.$loading({
        lock: true,
        text: '打开中，请稍后！',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      previewPdf(seePdfUrl, loading,this);
    },
    clickShow1(){
      this.show1 = !this.show1;
      let widthNum = this.show1?77:450;
      this.width =this.show1?'450px':'77px';
      let winWidth = document.documentElement.clientWidth;
      let beforeLeft = this.left + widthNum - 12;
      let nowWidth = this.show1?450:77;
      debugger
      if(beforeLeft>winWidth - nowWidth - 30){
        this.left = winWidth - 12 - nowWidth;
      }
    },
    initLeftATop(){
      this.clientWidth = document.documentElement.clientWidth;
      this.clientHeight = document.documentElement.clientHeight;
      this.dragElement = document.querySelector('#floatDrag');
      if(this.dragElement){
        const rect = this.dragElement.getBoundingClientRect();
        this.left = this.clientWidth - rect.width -12;
        this.top = this.clientHeight - rect.height -12;
      }
    },
    startDrag(event) {
      this.dragElement = document.querySelector('#floatDrag');
      this.isDragging = true;
      this.startX = event.clientX;
      this.startY = event.clientY;
      this.dragBoxOffsetX = this.dragElement.offsetLeft;
      this.dragBoxOffsetY = this.dragElement.offsetTop;
      document.addEventListener('mousemove', this.doDrag);
      document.addEventListener('mouseup', this.stopDrag);
      document.addEventListener('mouseleave', this.stopDrag);
    },
    doDrag(event) {
      document.ondragstart = function(ev) {
        ev.preventDefault();
      };
      document.ondragend = function(ev) {
          ev.preventDefault();
      };
      if (this.isDragging) {
        let winHeight = document.querySelector('#app').scrollHeight;
        let winWidth = document.documentElement.clientWidth;
        const dx = event.clientX - this.startX;
        const dy = event.clientY - this.startY;
        let left = this.dragBoxOffsetX + dx;
        let top = this.dragBoxOffsetY + dy;
        left = Math.min(left, winWidth - this.dragElement.offsetWidth -12);
        top = Math.min(top, winHeight - 280);
        left = Math.max(left, 12);
        top = Math.max(top, 12);
        this.left = left;
        this.top = top;
      }
    },
    stopDrag() {
      this.isDragging = false;
      document.removeEventListener('mousemove', this.doDrag);
      document.removeEventListener('mouseup', this.stopDrag);
      document.removeEventListener('mouseleave', this.stopDrag);
    }
  },
};
</script>

<style lang="scss" scoped>
.draw-enter-active,
.draw-leave-active {
  transition: all 0.3s easeInout;
  max-height: 100px;
}

.draw-enter,
.draw-leave-to {
  height: 0;
  opacity: 0;
}

.drawdowm-enter-active,
.drawdowm-leave-active {
  transition: all 0.3s easeInout;
  max-height: 100px;
}

.drawdowm-enter,
.drawdowm-leave-to {
  height: 0;
  opacity: 0;
}
.helpIconPage{
  max-height: 186px;
  min-height: 120px;
  min-width: 77px;
  max-width:450px ;
  position:absolute;
}
.right_top {
  cursor: pointer;
  max-height: 186px;
  min-height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  right: 0px;
  top: 70%;
  background: #188fffd1;
  color: #ffffff;
  overflow: hidden;
  z-index: 9999;
  position: relative;
  padding: 5px;
  text-align: center;
  width: 450px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;

  .right_all {
    // width: 190px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .left_img {
      margin-left: 2%;
    }
    .iphone_text {
      width: 320px;
      margin-left: 10px;
      margin-right: 4%;
      font-size: 1em;
    }
  }
}
</style>